export function ReportFormats() {
    return [
        {
            name: 'PDF',
            value: 'pdf',
        },
        {
            name: 'Excel',
            value: 'excel',
        },
        {
            name: 'Word (DOCX)',
            value: 'docx',
        }
    ];
}